module.exports = __webpack_public_path__ + "img/pg4-article-title4-inner.3de81135.png";